import React from 'react';
import { Breadcrumbs } from '../components/ui/Breadcrumbs';
import { useLanguage } from '../i18n/LanguageContext';
interface PublicOfferPageProps {
  onNavigate: (page: string) => void;
}
export function PublicOfferPage({
  onNavigate
}: PublicOfferPageProps) {
  const {
    t
  } = useLanguage();
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-26952">
      <div className="bg-white border-b border-slate-200 pt-6 pb-12" data-id="element-26953">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26954">
          <Breadcrumbs items={[{
          label: t('legal.backToHome'),
          onClick: () => onNavigate('home')
        }, {
          label: t('legal.offer.title')
        }]} className="mb-8" data-id="element-26955" />
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-26956">
            {t('legal.offer.title')}
          </h1>
          <p className="text-slate-500" data-id="element-26957">{t('legal.lastUpdated')}</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-26958">
        <div className="bg-white rounded-2xl p-8 sm:p-12 border border-slate-200 shadow-sm prose prose-slate max-w-none" data-id="element-26959">
          <h2 data-id="element-26960">{t('legal.offer.s1.title')}</h2>
          <p data-id="element-26961">{t('legal.offer.s1.p1')}</p>

          <h2 data-id="element-26962">{t('legal.offer.s2.title')}</h2>
          <p data-id="element-26963">{t('legal.offer.s2.p1')}</p>

          <h2 data-id="element-26964">{t('legal.offer.s3.title')}</h2>
          <p data-id="element-26965">{t('legal.offer.s3.p1')}</p>

          <h2 data-id="element-26966">{t('legal.offer.s4.title')}</h2>
          <p data-id="element-26967">{t('legal.offer.s4.p1')}</p>

          <h2 data-id="element-26968">{t('legal.offer.s5.title')}</h2>
          <p data-id="element-26969">{t('legal.offer.s5.p1')}</p>

          <h2 data-id="element-26970">{t('legal.offer.s6.title')}</h2>
          <p data-id="element-26971">{t('legal.offer.s6.p1')}</p>

          <h2 data-id="element-26972">{t('legal.offer.s7.title')}</h2>
          <p data-id="element-26973">{t('legal.offer.s7.p1')}</p>

          <h2 data-id="element-26974">{t('legal.offer.s8.title')}</h2>
          <p data-id="element-26975">{t('legal.offer.s8.p1')}</p>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm" data-id="element-26976">
          <button onClick={() => onNavigate('terms')} className="text-indigo-600 hover:text-indigo-800 font-medium transition-colors" data-id="element-26977">
            {t('legal.terms.title')} →
          </button>
          <button onClick={() => onNavigate('contact')} className="text-slate-500 hover:text-slate-700 font-medium transition-colors" data-id="element-26978">
            {t('legal.contactUs')}
          </button>
        </div>
      </div>
    </div>;
}